import React, { useEffect } from "react";

export default function useReactRefresh() {


  const validLocations = ["https://claritycooperative.com", "https://clarityfrontenddev.topsdemo.org", "https://clarityfrontend.topsdemo.org", "https://clarityqa.topsdemo.org"]

  useEffect(() => {
    if (validLocations.includes(window.location.origin)) {
      const count = localStorage.getItem("reloadCount");
      if (!isNaN(count) && parseInt(count) >= 3) {
        localStorage.setItem("reloadCount", "0");
        window.location = "/dashboard";
      } else {
        isNaN(count) ? localStorage.setItem("reloadCount", "1") : localStorage.setItem("reloadCount", (parseInt(count) + 1).toString());
        window.location.reload();
      }
    }
  }, []);
}
